// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"d00af65a","266":"d9dba5bd","809":"a9a679ab"}[chunkId] + ".css";
};